module.exports = __webpack_public_path__ + "img/JL-pin.464316ea.png";